import * as React from 'react';
import { useEffect, useState } from "react";
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Collapse from 'antd/lib/collapse';
import Select from 'antd/lib/select';
import Modal from 'antd/lib/modal';
import Input from 'antd/lib/input';
import Form from 'antd/lib/form';
import TextArea from 'antd/lib/input/TextArea';
import Typography from "antd/lib/typography";
import {NewIncidentModalProps} from "./incidentmodalprops";

const { Text } = Typography;
const { Panel } = Collapse;

import {
    useDispatch,
    useSelector,
  } from 'react-redux';


const {
    Option,
} = Select;

export const NewIncidentModalEnable = (
    props: NewIncidentModalProps
) => {
    
    const dispatch = useDispatch();
    const [number] = useState("");
    const [openedby, setOpenedBy] = useState("");
    const [incidentcategory, setIncidentCategory] = useState("");
    const [incidentstatus, setIncidentStatus] = useState("");
    const [incidentsubject, setIncidentSubject] = useState("");
    const [incidentdescription, setIncidentDescription] = useState("");
    const [openedincidentat] = useState("")
    const [ismodalvisible,setIsModalVisible] = useState(false)
    const [incidentnumber] = useState("");
    const servicenowinfo = useSelector((state:any) => (state.servicenowcaller));
    const incidentsinfo = useSelector((state:any)=> (state.getincidents));
    const createincidentsdata = useSelector((state:any)=> (state.createincident));
    const incidentmodaldata = useSelector((state:any)=> (state.incidentmodalvalue));
    const [category,setCategory] = useState([]);
    const [status,setStatus] =  useState([]);

    let email = "", name ="", statusnumber = "";
    const states = [{
        value: '1',
        label: 'New',
      }, {
        value: '2',
        label: 'In Progress',
      }, {
        value: '3',
        label: 'On Hold',
      }, {
        value: '6',
        label: 'Resolved',
      }, {
        value: '7',
        label: 'Closed',
      }, {
        value: '8',
        label: 'Cancelled',
      }]

  useEffect(() => {
    if (incidentsinfo?.callerincidentdata && incidentsinfo?.callerincidentdata?.length > 0) {
      let categoryarray: any = [], statusarray: any = [];
      incidentsinfo.callerincidentdata.forEach((categorydata: any) => {
        if (categorydata?.category && (!categoryarray.includes(categorydata?.category))) {
          categoryarray.push(categorydata?.category)
        }
        if (categorydata?.state && (!statusarray.includes(categorydata.state))) {
          statusarray.push(categorydata.state)
        }
      })
      //to set Category hooks for the dropdown in the for
      setCategory(categoryarray);
      //to set Status hooks for the dropdown in the file
      setStatus(statusarray);
    }
  }, [incidentsinfo]);
    useEffect(() => {

        if (servicenowinfo) {
            name = servicenowinfo?.selected?.name;
            email = servicenowinfo?.selected?.email
            setOpenedBy(name);
        }
    }, [servicenowinfo]);

    useEffect(() => {

      if (incidentmodaldata?.modalvisible) {
          setIsModalVisible(incidentmodaldata?.modalvisible)
      }
  }, [incidentmodaldata]);

    const handleCategoryChange = (event: any) => {
        setIncidentCategory(event)
      }
    
      const handleIncidentSubject = (event:any) => {
        setIncidentSubject(event.target.value);
      }
    
      const handleIncidentDescription = (event:any) => {
        setIncidentDescription(event.target.value);
      }

      const handleStatusChange = (event:any) =>{
        setIncidentStatus(event)
        if(states) {
          states.forEach((stateinfo:any)=> {
            if(stateinfo.label === event) {
              statusnumber = stateinfo.value;
            }
          })
        }
      }
    
    const onOk = () => {

        dispatch({
            type: "one-state-createincidents/fetch",
            payload: {
                caller_id: email,
                category: incidentcategory,
                description: incidentdescription,
                short_description: incidentsubject,
                state: statusnumber,
            }
        });
        dispatch({
            type:"one-state-linkincidents/fetch",
            payload: {
              interaction: number,
              task: incidentnumber
            }
      
          });
          setIsModalVisible(false)
          dispatch({
            type: "one-state-modalvalue/set",
            payload: {
              modalvisible: false
            }
          });
    };

    const onCancel = () => {
        setIsModalVisible(false)
        dispatch({
          type: "one-state-modalvalue/set",
          payload: {
            modalvisible: false
          }
        });
    }
        

    let incidentform = (
        <>
        <div>
        <Modal
          title={"New Incident"}
          visible={ismodalvisible}
          centered
          destroyOnClose
          onCancel={onCancel}
          onOk={onOk}
          okButtonProps={{ form: 'new-call-modal', htmlType: 'submit' }}
          okText={"Create & Link to the Call"}
          wrapClassName="custom-modal-wrap"
          width={650}
        >
          {createincidentsdata && (
            <div className="flex justify-end mb-5">
              <a
                href={`https://dev117142.service-now.com/nav_to.do?uri=incident.do?sys_id=${createincidentsdata.sys_id}`}
                target="_blank"
                className="open-servicenow-button"
              >
                Show in ServiceNow
              </a>

            </div>
          )}
          <Form id="new-call-modal">
            <Collapse defaultActiveKey={['1', '2']} className="ant-no-border-panel-collapse">
              <Panel header="Call Information" showArrow={false} key="1">
                <Row gutter={[16, 16]}>
                  <Col md={12} span={24}>
                    <text>Caller</text>
                    <Form.Item>
                      <Input name="caller_id" value={openedby} placeholder="Caller" readOnly />
                    </Form.Item>
                  </Col>
                  <Col md={12} span={24}>
                    <text>Opened</text>
                    <Form.Item>
                      <Input name="opened_at" value={openedincidentat} disabled={!openedincidentat} readOnly />
                    </Form.Item>
                  </Col>
                  <Col md={12} span={24}>
                    <text>Opened by</text>
                    <Form.Item>
                      <Input name="opened_by" value={openedby} placeholder="Opened by" readOnly />
                    </Form.Item>
                  </Col>
                  <Col md={12} span={24}>
                    <text>Category</text>
                    <Form.Item>
                    <Select placeholder="Category" value={incidentcategory} onChange={handleCategoryChange}>
                        {
                          category ? category.map((categoryoption: any, index: number) => (
                            <Option value={categoryoption} key={index}>{categoryoption}</Option>
                          )) : ""
                        }
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col md={12} span={24}>
                    <text>State</text>
                    <Form.Item>
                      <Select placeholder="State" value={incidentstatus} onChange={handleStatusChange}>
                        {
                          status ? status.map((statusoption: any, index: number) => (
                            <Option value={statusoption} key={index}>{statusoption}</Option>
                          )) : ""
                        }
                      </Select>
                    </Form.Item>
                  </Col>

                </Row>
              </Panel>
              <Panel header="Description" showArrow={false} key="2">
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <text>Subject</text>
                    <Form.Item>
                      <Input name="short_description" value={incidentsubject} placeholder="Subject" onChange={handleIncidentSubject} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <text>Description</text>
                    <Form.Item>
                      <TextArea name="description" value={incidentdescription} placeholder="Description" onChange={handleIncidentDescription} />
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>
            </Collapse>
          </Form>
        </Modal>
            </div>
        </>
    );
    return (
        <>
            {incidentform}
        </>
    );
}